import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy, DatePipe, CommonModule } from '@angular/common';
import { AppRoutes } from './app.routes';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Button, ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SpinnerModule } from 'primeng/spinner';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule, TableService } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { NgChartsModule } from 'ng2-charts';
// Services
import { AuthGuard } from '../security/auth-guard';
import { LoginAuthGuard } from '../security/login.auth';
import { AppServiceManager } from '../common/services/appServiceManager';
import { Configuration } from '../config/config';
// Components
import { AppComponent } from './app.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { AppLoginAdminComponent } from './pages/app.loginAdmin.component';
import { AppMenuComponent, AppSubMenuComponent } from './app.menu.component';
import { AppTopbarComponent } from './app.topbar.component';
import { VisitorDialogueComponent } from './VisitorManagement/IndependentVisitor/visitordialouge.component';
import { PettyCashDialougeComponent } from './IndependentPettyCash/pettycashdialouge.component';
import { PettyLendingDialogComponent } from './Petty Lending/petty-lending-dialog.component';


import { AppFooterComponent } from './app.footer.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppRightpanelComponent } from './app.rightpanel.component';
import { AppInlineProfileComponent } from './app.profile.component';

import { BreadcrumbService } from './breadcrumb.service';
import { PublicComponent } from './public/public.component';
import { SecureComponent } from './secure/secure.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SharedModule } from './shared/shared.module';
// import { AddVisitorComponent } from './VisitorManagement/addvisitor/addvisitor.component';
// import { VisitorsComponent } from './VisitorManagement/visitors/visitors.component';
import { FeesComponent } from './FeeManagement/fees/fees.component';
import { FeeComponent } from './FeeManagement/fee/fee.component';
// import { AttendanceListComponent } from './Attendance/attendance-list/attendance-list.component';
// import { AttendanceViewComponent } from './Attendance/attendance-view/attendance-view.component';
import { ConfirmationService } from 'primeng/api';
import { SecureGuard } from './secure/secureGaurd';
import { FullCalendarModule } from '@fullcalendar/angular';
// import { ReportsComponent } from './reports/reports.component';
import { GlobalComponent } from './global/global.component';
import { DataService } from './shared/data.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
// import { EnquiryListingComponent } from './enquiry/enquiry-listing/enquiry-listing.component';
// import { AddEnquiryComponent } from './enquiry/add-enquiry/add-enquiry.component';
// import { AttendenceReportComponent } from './reports/attendence-report/attendence-report.component';
import { AdmissionReportComponent } from './reports/admission-report/admission-report.component';
import { FeesPendingReportComponent } from './reports/fees-pending-report/fees-pending-report.component';
// import { PackageBuildersComponent } from './packageBuilder/package-builders/package-builders.component';
import { AuthService } from 'common/services/auth.service';
import { PackageBuilderModule } from './packageBuilder/package-builder.module';
//import { VisitorModule } from './VisitorManagement/visitor.module';
// import { DefaulterReportComponent } from './reports/defaulter-report/defaulter-report.component';
import { MemberService } from 'common/services/member.service';
import { RegisterCompanyComponent } from './pages/register-company/register-company.component';
import { RequestMangementModule } from './requests-management/request-mangement.module';
import { AuthInterceptor } from 'common/services/auth-interceptor';
// SLOTS & BOOKINGS COMPONENTS
// import { BookingSlotsComponent } from './bookingSlots/booking-slots/booking-slots.component';
// import { BookingSlotComponent } from './bookingSlots/booking-slot/booking-slot.component';
// import { BookingsComponent } from './bookings/bookings/bookings.component';
// import { BookingComponent } from './bookings/booking/booking.component';

import { BookingsManagementModule } from './bookings/bookings-management.module';
import { BookingSlotsManagementModule } from './bookingSlots/booking-slots-management.module';
import { FeesManagementModule } from './shared/feesManagement/fees-management.module';
import { AppFormFieldsComponent } from './global/components/app-form-fields/app-form-fields.component';
import { TrainingAttendenceReportComponent } from './reports/training-attendence-report/training-attendence-report.component';
// import { NewMemberReportComponent } from './reports/new-member-report/new-member-report.component';
// import { TrainerDefaulterReportComponent } from './reports/trainer-defaulter-report/trainer-defaulter-report.component';
import { NotificationsManagementModule } from './notification-center/notifications-management.module';
// import { DailyClosingReportComponent } from './reports/daily-closing-report/daily-closing-report.component';
// import { CheckInReportComponent } from './reports/check-in-report/check-in-report.component';
// import { UsersAttendanceReportComponent } from './reports/users-attendance-report/users-attendance-report.component';
// import { TrainerAttendanceReportComponent } from './reports/trainer-attendance-report/trainer-attendance-report.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LockListComponent } from './lock-list/lock-list.component';
import { RegisterBranchFromCompanyComponent } from './setting/BranchManagement/register-branch-from-company/register-branch-from-company.component';
import { PublicHeaderComponent } from './public/public-header/public-header.component';
import { PublicFooterComponent } from './public/public-footer/public-footer.component';
import { RegistrationComponent } from './public/registration/registration.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PaymentComponent } from './public/payment/payment.component';
import { EnquiryComponent } from './public/enquiry/enquiry.component';
import { VisitorComponent } from './public/visitor/visitor.component';
import { UserInformationComponent } from './pages/user-Infromation/user-information.component';
import { CookieModule } from 'ngx-cookie';
import { ActivityLogsComponent } from './activity-logs/activity-logs.component';
import { AssetsComponent } from './assets-management/assets.component';
import { AddAssetComponent } from './assets-management/add-assets/add-assets.component';
import { AssetDetailsComponent } from './assets-management/asset-details/asset-details.component';

import { LoginLogsComponent } from './public/login-logs/login-logs.component';
import { ContactUsComponent } from './public/contactus/contactus.component';

import { DesignationManagementComponent } from './hr-pay-management/designation-management/designation-management.component';
import { EmployeeSalaryManagementComponent } from './hr-pay-management/employee-salary-management/employee-salary-management.component';
import { PaySalaryToEmployeesComponent } from './hr-pay-management/components/pay-salary-to-employees/pay-salary-to-employees.component';

import { AddProductComponent } from './products/add-product/add-product.component';
import { ProductCategoryComponent } from './products/product-category/product-category.component';
import { ProductCategoriesComponent } from './products/product-categories/product-categories.component';
import { PointOfSaleComponent } from './Sales/point-of-sale/point-of-sale.component';
import { SaleOrdersComponent } from './Sales/sale-orders/sale-orders.component';
import { EmployeesListingComponent } from './Employees/employees-listing/employees-listing.component';
import { AddEmployeeComponent } from './Employees/add-employee/add-employee.component';
import { SupplierListingComponent } from './supplier/supplier-listing/supplier-listing.component';
import { AddSupplierComponent } from './supplier/add-supplier/add-supplier.component';
import { PurchaseOrderComponent } from './supplier/purchase-order/purchase-order.component';
import { PurchaseOrdersComponent } from './supplier/purchase-orders/purchase-orders.component';

import { SupplierComponent } from './supplier/supplier.component';
import { UpdateStockCountComponent } from './products/update-stock-count/update-stock-count.component';
import { ProductsListingComponent } from './products/products-listing/products-listing.component';
import { PettyCashComponent } from './petty-cash/petty-cash.component';
import { TrainingSessionsComponent } from './training-sessions/training-sessions.component';
import { SelfSessionsComponent } from './self-sessions/self-sessions.component';
import { TrainerDashboardComponent } from './trainer-dashboard/trainer-dashboard.component';
import { FeesApprovalComponent } from './FeesApproval/feesApproval.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ShortCurrencyPipe } from 'pipes/short-currency.pipe';

@NgModule({
    imports: [
        NgChartsModule,
        StepsModule,
        ToastModule,
        BrowserModule,
        SharedModule,
        PackageBuilderModule,
        FeesManagementModule,
        AppRoutes,
        NgChartsModule,
        HttpClientModule,
        RadioButtonModule,
        BrowserAnimationsModule,
        AutoCompleteModule,
        BreadcrumbModule,
        CarouselModule,
        ChartModule,
        ChipsModule,
        InputTextModule,
        ContextMenuModule,
        FieldsetModule,
        GalleriaModule,
        InplaceModule,
        InputMaskModule,
        InputSwitchModule,
        RadioButtonModule,
        InputTextModule,
        InputTextareaModule,
        MegaMenuModule,
        MenuModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RatingModule,
        ScrollPanelModule,
        SelectButtonModule,
        ButtonModule,
        SlideMenuModule,
        SliderModule,
        SpinnerModule,
        SplitButtonModule,
        TerminalModule,
        TieredMenuModule,
        ToggleButtonModule,
        ToolbarModule,
        TreeModule,
        DataViewModule,
        FormsModule,
        ReactiveFormsModule,
        TabMenuModule,
        FullCalendarModule,
        CalendarModule,
        PanelModule,
        TabViewModule,
        ConfirmDialogModule,
        DialogModule,
        TableModule,
        CommonModule,
        DropdownModule,
        ReactiveFormsModule,
        TreeTableModule,
        VirtualScrollerModule,
        RequestMangementModule,
        BookingsManagementModule,
        BookingSlotsManagementModule,
        NotificationsManagementModule,
        NgxSpinnerModule,
        MessagesModule,
        MessageModule,
        ImageCropperModule,
        ProgressSpinnerModule,
        CheckboxModule,

        CookieModule.forRoot()
    ],
    declarations: [
        AppComponent,
        AppMenuComponent,
        AppSubMenuComponent,
        AppTopbarComponent,
        DesignationManagementComponent,
        EmployeeSalaryManagementComponent,
        PaySalaryToEmployeesComponent,
        AddProductComponent,
        ProductCategoryComponent,
        ProductCategoriesComponent,
        PettyCashComponent,
        FeesApprovalComponent,
        TrainingSessionsComponent,
        SelfSessionsComponent,
        TrainerDashboardComponent,
        DashboardComponent,
        PointOfSaleComponent,
        ProductsListingComponent,
        SaleOrdersComponent,
        EmployeesListingComponent,
        AddEmployeeComponent,
        SupplierListingComponent,
        AddSupplierComponent,
        PurchaseOrderComponent,
        PurchaseOrdersComponent,
        SupplierComponent,
        UpdateStockCountComponent,
        AppFooterComponent,
        AppBreadcrumbComponent,
        AppRightpanelComponent,
        AppInlineProfileComponent,
        AppNotfoundComponent,
        AppErrorComponent,
        AppAccessdeniedComponent,
        AppLoginComponent,
        AppLoginAdminComponent,
        PublicComponent,
        SecureComponent,
        ResetPasswordComponent,
        // AddVisitorComponent,
        // VisitorsComponent,
        FeesComponent,
        FeeComponent,
        // AttendanceListComponent,
        // AttendanceViewComponent,
        // ReportsComponent,
        GlobalComponent,
        // EnquiryListingComponent,
        // AddEnquiryComponent,
        // AttendenceReportComponent,
        AdmissionReportComponent,
        FeesPendingReportComponent,
        // DefaulterReportComponent,
        RegisterCompanyComponent,
        AppFormFieldsComponent,
        TrainingAttendenceReportComponent,
        // NewMemberReportComponent,
        // TrainerDefaulterReportComponent,
        // DailyClosingReportComponent,
        // CheckInReportComponent,
        // UsersAttendanceReportComponent,
        // TrainerAttendanceReportComponent,
        LockListComponent,
        RegisterBranchFromCompanyComponent,
        PublicHeaderComponent,
        PublicFooterComponent,
        RegistrationComponent,
        PaymentComponent,
        EnquiryComponent,
        VisitorComponent,
        UserInformationComponent,
        ActivityLogsComponent,
        AssetsComponent,
        AddAssetComponent,
        AssetDetailsComponent,
        LoginLogsComponent,
        ContactUsComponent,
        VisitorDialogueComponent,
        PettyCashDialougeComponent,
        PettyLendingDialogComponent,
        ShortCurrencyPipe,
        // BookingSlotsComponent,
        // BookingSlotComponent,
        // BookingsComponent,
        // BookingComponent,
        // PackageBuildersComponent,
        // PackageBuilderComponent,
        // AddpackageBuilderComponent
        
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy }, { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, DatePipe,
        AuthService,
        BreadcrumbService, DataService,
        AuthGuard, LoginAuthGuard, AppServiceManager, SecureGuard, MemberService, Configuration, ConfirmationService, TableService, Button


    ],
    bootstrap: [AppComponent],
    exports: [
    ShortCurrencyPipe
  ]
})
export class AppModule { }
